import _ from 'lodash'

import {
  START_DRAG,
  STOP_DRAG,
} from 'react-redux/actions/drag-and-drop'

import { RESET } from 'react-redux/actions/app'

const initialDragAndDropState = {
  domain: null,
  uid: null,
  opts: null
}

const dragAndDrop = (state = initialDragAndDropState, action) => {
  switch (action.type) {
    case RESET: {
      return _.cloneDeep(initialDragAndDropState)
    }
    case START_DRAG: {
      return Object.assign(
        {},
        state,
        {
          domain: action.domain,
          uid: action.uid,
          opts: action.opts
        }
      )
    }
    case STOP_DRAG: {
      return Object.assign({}, state, initialDragAndDropState)
    }
    default:
      return state
  }
}

export default dragAndDrop



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/drag-and-drop.js